import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import {
  Box, Button, Typography, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Checkbox, IconButton, TextField, InputAdornment, MenuItem,
  Select, Chip, Avatar, Dialog, DialogTitle, DialogContent, Card,
  CardContent,
  CardActions, DialogActions, RadioGroup, Radio, Grid, FormControlLabel, Menu,
  FormControl, InputLabel, useTheme, CircularProgress
} from "@mui/material";
import { Helmet } from "react-helmet";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadIcon from '@mui/icons-material/Upload';
import VisibilityIcon from '@mui/icons-material/Visibility';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import { useNavigate } from "react-router-dom";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MusicNoteIcon from '@mui/icons-material/MusicNote';

import SectionLoader from "../components/SectionLoader";
import Toast from "../components/Toast";
import ConfirmDialog from "../components/ConfirmDialog";
import Tooltip from '@mui/material/Tooltip';
import SettingsIcon from '@mui/icons-material/Settings';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ModuleSettingsModal from "../components/ModuleSettingsModal";
import ModuleAnalyticsDashboard from "../components/ModuleAnalyticsDashboard";
import ArchiveIcon from "@mui/icons-material/Archive";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import InventoryIcon from "@mui/icons-material/Inventory";
import ArchiveManager from "../utils/archiveManager";
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import MobileSongPreviewModal from "../components/MobileSongPreviewModal";

import { useUser } from "../context/UserContext";
const statusColors = {
  1: "success",
  2: "warning",
  3: "default"
};





export const getSongLanguage = (songItem) => {
  const langId = songItem?.language_id ?? songItem?.songs?.language_id;
  const numId = Number(langId);

  const textToCheck = `${songItem?.title || ''} ${songItem?.songs?.title || ''} ${songItem?.song || ''} ${songItem?.songs?.song || ''}`;
  if (/[\u0C00-\u0C7F]/.test(textToCheck)) {
    return 'Telugu';
  }
  if (/[\u0900-\u097F]/.test(textToCheck)) {
    return 'Hindi';
  }

  if (numId === 2) return 'Telugu';
  if (numId === 3) return 'Hindi';
  return 'English';
};

const Songs = () => {
  const theme = useTheme();
  const isLight = theme.palette.mode === 'light';
  const [viewMode, setViewMode] = useState("content"); // 'content' | 'analytics'
  const [search, setSearch] = useState("");
  const [language, setLanguage] = useState("All Languages");
  const [songType, setSongType] = useState('2'); // default to true or false based on your app  
  const [selected, setSelected] = useState([]);
  const [selectedSongs, setSelectedSongs] = useState([]);
  const [songs, setSongs] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [organization, setOrganization] = useState(null); // or orgOptions[0] for default
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const { user } = useUser();
  const isOrgSwitched = !!(() => { try { return JSON.parse(sessionStorage.getItem('gpn_org_view_mode')); } catch { return null; } })();
  const [openDialog, setOpenDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [selectedSongForView, setSelectedSongForView] = useState(null);
  const [songDetailModalOpen, setSongDetailModalOpen] = useState(false);
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({ open: false, title: '', message: '', onConfirm: null });
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [status, setStatus] = useState(1); // Default status for adding to My Songs
  const [archivedList, setArchivedList] = useState(() => ArchiveManager.getArchivedItems('songs'));
  const [filterActiveTab, setFilterActiveTab] = useState('all');
  const [reloadCounter, setReloadCounter] = useState(0);
  const [mobileExampleOpen, setMobileExampleOpen] = useState(false);

  // Section & Sub-tabs States (All, songs, pdf songs, import songs)
  const [activeSourceTab, setActiveSourceTab] = useState("All");
  const [allViewMode, setAllViewMode] = useState("cards"); // 'cards' | 'table'
  const [songCategoryTab, setSongCategoryTab] = useState("all"); // 'all' | 'songs' | 'pdf_songs' | 'import_songs'
  const [customSections, setCustomSections] = useState(() => {
    try {
      const stored = localStorage.getItem("gpn_songs_custom_sections");
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });
  const [newSectionModalOpen, setNewSectionModalOpen] = useState(false);
  const [newSectionName, setNewSectionName] = useState("");
  const [newSectionDesc, setNewSectionDesc] = useState("");
  const [duplicateConfirmDialog, setDuplicateConfirmDialog] = useState({
    open: false,
    duplicates: [],
    title: "",
    message: "",
    onConfirmReplace: null,
    onConfirmSkip: null
  });

  // PDF Songs States
  const [pdfSongs, setPdfSongs] = useState([]);
  const [loadingPdfs, setLoadingPdfs] = useState(false);
  const [selectedPdfUrl, setSelectedPdfUrl] = useState(null);
  const [pdfSearch, setPdfSearch] = useState("");

  // CSV Import States
  const [openCsvDialog, setOpenCsvDialog] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [csvPreviewData, setCsvPreviewData] = useState([]);
  const [csvImporting, setCsvImporting] = useState(false);

  const navigate = useNavigate();

  // Download Sample CSV Template
  const downloadSampleCsv = () => {
    const csvContent =
      '\uFEFF' +
      'Song Number,Title,Language,Author,Lyrics,English Title,English Lyrics,Copyright\n' +
      '1,"Amazing Grace",English,"John Newton","Amazing grace! how sweet the sound\nThat saved a wretch like me!\nI once was lost, but now am found,\nWas blind, but now I see.","Amazing Grace","Amazing grace! how sweet the sound That saved a wretch like me!",no\n' +
      '2,"యేసు నామము అత్యున్నతమైనది",Telugu,"Pastor John","యేసు నామము అత్యున్నతమైనది\nఅన్ని నామముల కన్నా ఘనమైనది\nపరలోకమందున భూలోకమందున\nఘనపరచదగిన నామము","Yesu Naamamu Athyunnathamainadhi","Yesu Naamamu Athyunnathamainadhi Anni Naamamula Kanna Ghanamainadhi",no\n' +
      '3,"येशू नाम सबसे ऊंचा है",Hindi,"Bro. David","येशू नाम सबसे ऊंचा है\nसारे नामों से बढ़कर है\nस्वर्ग में और पृथ्वी पर\nवही एक उद्धारकर्ता है","Yeshu Naam Sabse Uncha Hai","Yeshu Naam Sabse Uncha Hai Saare Naamo Se Badhkar Hai",no\n';

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'sample_songs_template.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  // Client-side CSV Parser for live preview
  const parseClientCsv = (text) => {
    if (!text) return [];
    let cleanText = text.replace(/^\uFEFF/, '');
    const rows = [];
    let currentRow = [];
    let currentVal = '';
    let inQuotes = false;

    for (let i = 0; i < cleanText.length; i++) {
      const char = cleanText[i];
      const nextChar = cleanText[i + 1];

      if (inQuotes) {
        if (char === '"') {
          if (nextChar === '"') {
            currentVal += '"';
            i++;
          } else {
            inQuotes = false;
          }
        } else {
          currentVal += char;
        }
      } else {
        if (char === '"') {
          inQuotes = true;
        } else if (char === ',') {
          currentRow.push(currentVal.trim());
          currentVal = '';
        } else if (char === '\r') {
          if (nextChar === '\n') i++;
          currentRow.push(currentVal.trim());
          rows.push(currentRow);
          currentRow = [];
          currentVal = '';
        } else if (char === '\n') {
          currentRow.push(currentVal.trim());
          rows.push(currentRow);
          currentRow = [];
          currentVal = '';
        } else {
          currentVal += char;
        }
      }
    }

    if (currentVal || currentRow.length > 0) {
      currentRow.push(currentVal.trim());
      rows.push(currentRow);
    }

    if (rows.length < 2) return [];

    const headers = rows[0].map(h => h.toLowerCase().replace(/[\s_-]+/g, '_'));
    const results = [];

    for (let r = 1; r < rows.length; r++) {
      const row = rows[r];
      if (row.length === 1 && !row[0]) continue;
      if (row.every(c => !c)) continue;

      const rowObj = {};
      headers.forEach((h, colIndex) => {
        rowObj[h] = row[colIndex] !== undefined ? row[colIndex] : '';
      });
      results.push(rowObj);
    }

    return results;
  };

  const handleCsvFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setCsvFile(file);

    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const text = event.target.result;
        const parsed = parseClientCsv(text);
        setCsvPreviewData(parsed);
      } catch (err) {
        console.error("Error parsing CSV preview:", err);
      }
    };
    reader.readAsText(file);
  };

  const handleImportCsvSubmit = async (replaceDuplicates = false, skipDuplicates = false) => {
    if (!csvFile && csvPreviewData.length === 0) {
      setToast({ open: true, message: "Please select a .csv file first.", severity: "warning" });
      return;
    }

    // Check for duplicate song titles before uploading if not yet confirmed
    if (!replaceDuplicates && !skipDuplicates) {
      const existingTitles = new Set(
        songs.map(s => (s.title || s.songs?.title || '').trim().toLowerCase()).filter(Boolean)
      );
      const duplicatesFound = csvPreviewData.filter(row =>
        row.title && existingTitles.has(row.title.trim().toLowerCase())
      );

      if (duplicatesFound.length > 0) {
        setDuplicateConfirmDialog({
          open: true,
          duplicates: duplicatesFound,
          title: "Duplicate Song Detected",
          message: `The song "${duplicatesFound[0].title}" ${duplicatesFound.length > 1 ? `and ${duplicatesFound.length - 1} other songs are` : 'is'} already in the songbook. Would you like to replace the existing song with this new version?`,
          onConfirmReplace: () => {
            setDuplicateConfirmDialog(prev => ({ ...prev, open: false }));
            handleImportCsvSubmit(true, false);
          },
          onConfirmSkip: () => {
            setDuplicateConfirmDialog(prev => ({ ...prev, open: false }));
            handleImportCsvSubmit(false, true);
          }
        });
        return;
      }
    }

    setCsvImporting(true);
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      if (csvFile) {
        formData.append("file", csvFile);
      }
      if (csvPreviewData.length > 0) {
        formData.append("songs", JSON.stringify(csvPreviewData));
      }
      if (replaceDuplicates) {
        formData.append("replace_duplicates", "true");
      }

      const response = await fetch(`${API_URL}import-csv-songs`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formData
      });

      const data = await response.json();
      if (response.ok && data.success) {
        setToast({
          open: true,
          message: data.message || `Successfully imported ${data.importedCount || csvPreviewData.length} songs!`,
          severity: "success"
        });
        setOpenCsvDialog(false);
        setCsvFile(null);
        setCsvPreviewData([]);
        setPage(1);
        setSongCategoryTab('import_songs'); // switch to Import Songs sub-tab
        setReloadCounter(prev => prev + 1);
      } else {
        setToast({
          open: true,
          message: data.message || "Failed to import songs from CSV",
          severity: "error"
        });
      }
    } catch (err) {
      console.error("Error importing CSV:", err);
      setToast({ open: true, message: "Network error importing CSV", severity: "error" });
    } finally {
      setCsvImporting(false);
    }
  };

  const fetchPdfSongs = async () => {
    try {
      setLoadingPdfs(true);
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}songs-pdf-list`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (response.ok && data.success !== false) {
        setPdfSongs(data.data || []);
      }
    } catch (err) {
      console.error("Error fetching PDF songs:", err);
    } finally {
      setLoadingPdfs(false);
    }
  };

  const handleDeletePdf = async (pdfId) => {
    setConfirmDialog({
      open: true,
      title: "Delete PDF Song",
      message: "Are you sure you want to delete this PDF song? This cannot be undone.",
      onConfirm: async () => {
        setConfirmDialog(prev => ({ ...prev, open: false }));
        try {
          const token = localStorage.getItem("token");
          const response = await fetch(`${API_URL}delete-pdf-song`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ id: pdfId })
          });
          const data = await response.json();
          if (response.ok && data.success) {
            setToast({ open: true, message: "PDF song deleted successfully", severity: "success" });
            fetchPdfSongs();
          } else {
            setToast({ open: true, message: data?.message || "Failed to delete PDF song", severity: "error" });
          }
        } catch (err) {
          setToast({ open: true, message: "Error deleting PDF song", severity: "error" });
        }
      }
    });
  };

  const handleCreateNewSection = () => {
    if (!newSectionName.trim()) {
      setToast({ open: true, message: "Please provide a collection/section name.", severity: "warning" });
      return;
    }
    const newSection = {
      id: `sec_${Date.now()}`,
      name: newSectionName.trim(),
      description: newSectionDesc.trim() || "Custom song collection",
      created_at: new Date().toISOString()
    };
    const updated = [...customSections, newSection];
    setCustomSections(updated);
    try {
      localStorage.setItem('gpn_songs_custom_sections', JSON.stringify(updated));
    } catch (e) {
      console.error(e);
    }
    setNewSectionModalOpen(false);
    setNewSectionName("");
    setNewSectionDesc("");
    setActiveSourceTab(newSection.name);
    setToast({ open: true, message: `Collection "${newSection.name}" created successfully!`, severity: "success" });
  };

  const handleArchive = (songItem) => {
    setConfirmDialog({
      open: true,
      title: "Archive Song",
      message: "Are you sure you want to archive this song? It will no longer be visible in the mobile app songbook until restored.",
      onConfirm: () => {
        ArchiveManager.archiveItem('songs', songItem);
        setArchivedList(ArchiveManager.getArchivedItems('songs'));
        setConfirmDialog({ open: false, title: '', message: '', onConfirm: null });
        setToast({ open: true, message: "Song archived and hidden from mobile app.", severity: "info" });
      }
    });
  };

  const handleRestore = (songId) => {
    ArchiveManager.restoreItem('songs', songId);
    setArchivedList(ArchiveManager.getArchivedItems('songs'));
    setToast({ open: true, message: "Song restored to active songbook!", severity: "success" });
  };

  const handlePermanentDelete = (songId) => {
    setConfirmDialog({
      open: true,
      title: "Permanently Delete Song",
      message: "Are you sure you want to permanently delete this archived song? This cannot be undone.",
      onConfirm: () => {
        ArchiveManager.deletePermanently('songs', songId);
        setArchivedList(ArchiveManager.getArchivedItems('songs'));
        setConfirmDialog({ open: false, title: '', message: '', onConfirm: null });
        setToast({ open: true, message: "Song permanently deleted.", severity: "success" });
      }
    });
  };

  const [DisplayType, setDisplayType] = useState('Both'); // default to true or false based on your app

  const API_URL = process.env.REACT_APP_API_URL || 'http://45.194.3.128:4000/api/admin/';
  const [eventName, seteventName] = useState('');
  const [description, Setdescription] = useState('');
  const [loading, setLoading] = useState(true);

  const [origanisation, SetOriganisation] = useState('');
  const [image, Setimage] = useState({
    file: null,
    preview: '',
  });

  const [id, setId] = useState(null);


  const orgOptions = [{ id: 0, org_name: "All Organizations" }, ...(organizations || [])];

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = songs.map((song) => song.id);
      const allSongs = songs.map((song) => ({
        id: song.id,
        name: song.title
      }));
      setSelected(allIds);
      setSelectedSongs(allSongs);
    } else {
      setSelected([]);
      setSelectedSongs([]);
    }
  };



  const handleSelect = (songId, songName) => {
    setSelected((prev) => {
      const exists = prev.includes(songId);
      if (exists) {
        // Remove from selected IDs
        setSelectedSongs((songs) => songs.filter((s) => s.id !== songId));
        return prev.filter((id) => id !== songId);
      } else {
        // Add to selected IDs
        setSelectedSongs((songs) => [...songs, { id: songId, name: songName }]);
        return [...prev, songId];
      }
    });
  };



  useEffect(() => {

   if (user?.role !== 1 && user?.org_id) {
      fetchSettings(user?.org_id);
    } else {
      setSongType('1');
    }

  }, [user]); // run when user changes

  const fetchSettings = async (org_id) => {
    try {
      const token = localStorage.getItem("token");

      const response = await fetch(`${API_URL}settings`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ organization_id: org_id }),
      });

      const data = await response.json();

      if (!response.ok || data.success === false) {
          // ðŸ”‘ Handle invalid token
          if (data.message === 'Invalid token') {
            localStorage.removeItem('token');
            window.location.href = '/login';
            return;
          }
       }

      if (data?.settings?.length > 0) {
        setDisplayType(data.settings[0].songs_display);
        setId(data.settings[0].id || null);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        const storedOrgMode = sessionStorage.getItem('gpn_org_view_mode');
        const orgViewMode = storedOrgMode ? JSON.parse(storedOrgMode) : null;
        const effectiveOrgId = orgViewMode?.orgId ? orgViewMode.orgId : (organization && organization.id !== 0 ? organization.id : null);

        const response = await fetch(`${API_URL}filter-songs`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            search: search,
            song_type: songType,
            organization: effectiveOrgId || null,
            page: page,
            pageSize: pageSize,
            language_id: language
          })
        });
        const data = await response.json();

        if (!response.ok || data.success === false) {
          // ðŸ”‘ Handle invalid token
          if (data.message === 'Invalid token') {
            localStorage.removeItem('token');
            window.location.href = '/login';
            return;
          }
       }
        setSongs(data.data || []);
        setTotalItems(data.totalCount);
        setTotalPages(data.totalPages);
      } catch (err) {
        // setError('Network error. Please try again.');
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, [songType, language, organization, search, page, pageSize, reloadCounter]);

  useEffect(() => {
    const fetchRolesAndOrganizations = async () => {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}roles-organizations`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();

      if (!response.ok || data.success === false) {
          // ðŸ”‘ Handle invalid token
          if (data.message === 'Invalid token') {
            localStorage.removeItem('token');
            window.location.href = '/login';
            return;
          }
       }
      setOrganizations(data.organizations);




    };

    fetchRolesAndOrganizations();
  }, []);

  const handleEdit = (id) => {

    navigate('/admin/edit-song/' + id)

  };





  const handleSongsSettings = async () => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}update-songs-settings`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        // âŒ Do NOT set 'Content-Type' when sending FormData
      },
      body: JSON.stringify({
        display_type: DisplayType,
        settingId: id,
      }),
    });
    const data = await response.json();

    if (!response.ok || data.success === false) {
          // ðŸ”‘ Handle invalid token
          if (data.message === 'Invalid token') {
            localStorage.removeItem('token');
            window.location.href = '/login';
            return;
          }
       }
    if (response.ok && (data.success || data.statusCode === 200)) {
      if (data.setting?.id) {
        setId(data.setting.id);
      }
      setToast({ open: true, message: "Songs display settings updated successfully!", severity: "success" });
    } else {
      setToast({ open: true, message: "Update failed: " + (data?.message || 'Unknown error'), severity: "error" });
    }
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };
  const handleDialogClose = () => {
    setOpenDialog(false);
  };


  const handleDelete = async (id) => {
    setConfirmDialog({
      open: true,
      title: 'Delete Song',
      message: 'Are you sure you want to delete this song? This action cannot be undone.',
      onConfirm: async () => {
        setConfirmDialog({ ...confirmDialog, open: false });

        try {
          const token = localStorage.getItem('token');

          const response = await fetch(`${API_URL}delete-song`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id }),
          });

          const data = await response.json();

          if (!response.ok || data.success === false) {
          // ðŸ”‘ Handle invalid token
          if (data.message === 'Invalid token') {
            localStorage.removeItem('token');
            window.location.href = '/login';
            return;
          }

          setToast({ open: true, message: data?.message || 'Failed to delete song', severity: "error" });
         }

            setToast({ open: true, message: "Song deleted successfully", severity: "success" });
            setTimeout(() => {
              window.location.reload();
            }, 1500);
         
        } catch (error) {
          console.error('Error deleting song:', error);
          setToast({ open: true, message: "An error occurred while deleting the song", severity: "error" });
        }
      }
    });
  };

  const ImportPdfSongs = async () => {
    if (!image.file || !eventName) {
      setToast({ open: true, message: "Please provide a title and select a PDF file.", severity: "warning" });
      return;
    }
    const formData = new FormData();
    formData.append('title', eventName);
    formData.append('file', image.file);
    formData.append('organization', origanisation);
    formData.append('description', description);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_URL}import-pdf-songs`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });
      const data = await response.json();


      if (!response.ok || data.success === false) {
          // ðŸ”‘ Handle invalid token
          if (data.message === 'Invalid token') {
            localStorage.removeItem('token');
            window.location.href = '/login';
            return;
          }

          setToast({ open: true, message: data?.message || 'Failed to delete song', severity: "error" });

        }


        setToast({ open: true, message: "PDF Songs imported successfully", severity: "success" });
        setOpenDialog(false);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
    
    } catch (error) {
      console.error('Error importing PDF Songs:', error);
      setToast({ open: true, message: "An error occurred while importing PDF Songs", severity: "error" });
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  const handleSelectOption = (status) => {
    setOpenViewDialog(true);
    setStatus(status);
  }
  const handleViewDialogClose = () => {
    setOpenViewDialog(false);
    //  setSelectedSongs([]);
  }
  const SongsaddtoOrganization = async () => {
    if (selected.length === 0) {
      setToast({ open: true, message: "Please select at least one song.", severity: "warning" });
      return;
    }
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_URL}add-songs-to-organization`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        songs: selected,
        status: status,
      }),
    });
    const data = await response.json();

    if (!response.ok || data.success === false) {
          // ðŸ”‘ Handle invalid token
          if (data.message === 'Invalid token') {
            localStorage.removeItem('token');
            window.location.href = '/login';
            return;
          }

          setToast({ open: true, message: data?.message || 'Failed to delete song', severity: "error" });

    }

      setToast({ open: true, message: status === 1 ? "Songs added to My Songs successfully" : "Songs removed from My Songs successfully", severity: "success" });
      setOpenViewDialog(false);
      setSelected([]);
      setSelectedSongs([]);
      setTimeout(() => {
        window.location.reload();
      }, 1500);
   
  };

  useEffect(() => {
    if (songs && songs.length > 0) {
      const initiallySelected = songs
        .filter((s) => s.is_added === 1)
        .map((s) => s.id);

      const initiallySelectedSongs = songs
        .filter((s) => s.is_added === 1)
        .map((s) => ({ id: s.id, name: s.title }));

      setSelected(initiallySelected);
      setSelectedSongs(initiallySelectedSongs);
    }
  }, [songs]);


  const displayedSongs = filterActiveTab === "archived"
    ? archivedList
    : songs.filter(s => !archivedList.some(a => String(a.id) === String(s.id)));

  // Group songs into sections / collections (default: "Glocal Prayer Network", and custom admin-created collections only)
  const songCollectionGroups = React.useMemo(() => {
    const groupsMap = {};

    // 1. Primary "Glocal Prayer Network" collection (always present as the default)
    groupsMap["Glocal Prayer Network"] = {
      name: "Glocal Prayer Network",
      count: 0,
      songs: [],
      latest: null,
      description: "Official default hymnal and prayer songbook",
      type: "organization"
    };

    // 2. Only add custom sections explicitly created by admin
    (customSections || []).forEach(sec => {
      if (sec.name && !groupsMap[sec.name]) {
        groupsMap[sec.name] = {
          name: sec.name,
          count: 0,
          songs: [],
          latest: null,
          description: sec.description || "Custom song collection",
          type: "custom"
        };
      }
    });

    // 3. Distribute current songs into collections
    displayedSongs.forEach(song => {
      const s = songType === '2' ? (song?.songs || song) : song;
      const customSec = s?.custom_section;

      let targetKey = "Glocal Prayer Network";
      if (customSec && groupsMap[customSec]) {
        targetKey = customSec;
      }

      groupsMap[targetKey].count += 1;
      groupsMap[targetKey].songs.push(song);
      if (!groupsMap[targetKey].latest) {
        groupsMap[targetKey].latest = s;
      }
    });

    return Object.values(groupsMap);
  }, [displayedSongs, customSections, songType]);

  // Filter songs by active section / collection
  const filteredBySection = React.useMemo(() => {
    if (activeSourceTab === 'All') return displayedSongs;
    return displayedSongs.filter(song => {
      const s = songType === '2' ? (song?.songs || song) : song;
      const customSec = s?.custom_section;
      if (activeSourceTab === 'Glocal Prayer Network') {
        return !customSec || customSec === 'Glocal Prayer Network';
      }
      return customSec === activeSourceTab;
    });
  }, [displayedSongs, activeSourceTab, songType]);

  // Filter songs according to the active 4 Sub-Tabs: All, Songs, PDF Songs, Import Songs
  const finalTabSongs = React.useMemo(() => {
    if (songCategoryTab === 'songs') {
      return filteredBySection.filter(s => !s.is_imported && !s.songs?.is_imported);
    }
    if (songCategoryTab === 'import_songs') {
      return filteredBySection.filter(s => s.is_imported || s.songs?.is_imported);
    }
    return filteredBySection;
  }, [filteredBySection, songCategoryTab]);

  return (
    <>    <Helmet>
      <title>Songs Management - GPN</title>
    </Helmet>

      <Box>
        {/* Header */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Box>
            <Typography variant="h5" fontWeight={700}>Songs Management</Typography>
            <Typography variant="body2" color="text.secondary">
              Manage default songs and organization specific collections.
            </Typography>
          </Box>

          {/* Top Right Action Icons */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* Songs Analytics Icon Button */}
            <Tooltip title="Songs Analytics" placement="bottom">
              <IconButton
                onClick={() => setViewMode(viewMode === "analytics" ? "content" : "analytics")}
                sx={{
                  color: viewMode === "analytics" ? "#FFFFFF" : (isLight ? "#0D9488" : "#64d2e2"),
                  bgcolor: viewMode === "analytics"
                    ? (isLight ? "#0D9488" : "#177373")
                    : (isLight ? "rgba(13, 148, 136, 0.1)" : "rgba(76, 161, 175, 0.15)"),
                  border: viewMode === "analytics"
                    ? "1.5px solid #64d2e2"
                    : (isLight ? "1.5px solid rgba(13, 148, 136, 0.35)" : "1px solid rgba(76, 161, 175, 0.35)"),
                  borderRadius: "8px",
                  p: 0.85,
                  transition: "all 0.2s ease-in-out",
                  boxShadow: viewMode === "analytics" ? "0 0 12px rgba(100, 210, 226, 0.4)" : "none",
                  "&:hover": {
                    bgcolor: viewMode === "analytics"
                      ? (isLight ? "#0f766e" : "#146262")
                      : (isLight ? "rgba(13, 148, 136, 0.2)" : "rgba(76, 161, 175, 0.3)"),
                    transform: "translateY(-1px)",
                  },
                }}
              >
                <AnalyticsIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>

            {/* Settings Icon Button */}
            <Tooltip title="Songs Settings" placement="bottom">
              <IconButton
                onClick={() => setSettingsOpen(true)}
                sx={{
                  color: isLight ? "#0D9488" : "#64d2e2",
                  bgcolor: isLight ? "rgba(13, 148, 136, 0.1)" : "rgba(76, 161, 175, 0.15)",
                  border: isLight ? "1.5px solid rgba(13, 148, 136, 0.35)" : "1px solid rgba(76, 161, 175, 0.35)",
                  borderRadius: "8px",
                  p: 0.85,
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    bgcolor: isLight ? "rgba(13, 148, 136, 0.18)" : "rgba(76, 161, 175, 0.3)",
                    borderColor: isLight ? "#0D9488" : "#4CA1AF",
                    transform: "rotate(30deg)",
                  },
                }}
              >
                <SettingsIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {viewMode === "analytics" ? (
          <ModuleAnalyticsDashboard
            contentType="song"
            moduleTitle="Songs Activity & Engagement Analytics"
            hideHeader={true}
          />
        ) : (
          <>
        {/* ── UNIFIED COMPACT TOOLBAR ── */}
        <Paper
          elevation={0}
          sx={{
            p: 1.5,
            px: 2,
            mb: 2,
            borderRadius: "12px",
            background: isLight ? "#FFFFFF" : "rgba(255, 255, 255, 0.04)",
            border: isLight ? "1.5px solid #CBD5E1" : "1px solid rgba(76, 161, 175, 0.25)",
            boxShadow: isLight ? "0 2px 8px rgba(15, 23, 42, 0.04)" : "none",
            display: "flex",
            flexDirection: "column",
            gap: 1.2,
          }}
        >
          {/* Row 1: Search Bar (Left) + Actions (Right) */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 1.2,
            }}
          >
            {/* Search Input */}
            <Box sx={{ flex: "1 1 260px", maxWidth: { xs: "100%", md: 400 } }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search by song name, author..."
                value={search}
                onChange={(e) => { setSearch(e.target.value); setPage(1); }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: isLight ? "#64748B" : "rgba(255,255,255,0.5)", fontSize: 19 }} />
                    </InputAdornment>
                  ),
                  endAdornment: search ? (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={() => { setSearch(""); setPage(1); }}>
                        <CloseIcon sx={{ fontSize: 15 }} />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: "8px",
                    bgcolor: isLight ? "#F8FAFC" : "rgba(255, 255, 255, 0.05)",
                    border: isLight ? "1px solid #CBD5E1" : "1px solid rgba(255, 255, 255, 0.15)",
                    color: isLight ? "#0F172A" : "#FFFFFF",
                    fontSize: "0.85rem",
                    '& fieldset': { border: 'none' },
                    '&:hover': { bgcolor: isLight ? "#FFFFFF" : "rgba(255, 255, 255, 0.08)" },
                    '&.Mui-focused': {
                      bgcolor: isLight ? "#FFFFFF" : "rgba(255, 255, 255, 0.08)",
                      boxShadow: '0 0 0 2px #0D9488',
                    },
                  },
                }}
              />
            </Box>

            {/* Right Buttons: Add, Import, View PDFs, Archived */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: { xs: 0, sm: "auto" }, flexWrap: "wrap" }}>
              <Button
                size="small"
                variant="outlined"
                startIcon={<PhoneIphoneIcon sx={{ fontSize: 16 }} />}
                onClick={() => setMobileExampleOpen(true)}
                sx={{
                  borderRadius: "8px",
                  borderColor: isLight ? "rgba(13, 148, 136, 0.4)" : "rgba(76, 161, 175, 0.4)",
                  bgcolor: isLight ? "rgba(13, 148, 136, 0.08)" : "rgba(76, 161, 175, 0.12)",
                  color: isLight ? "#0D9488" : "#64d2e2",
                  fontWeight: 700,
                  fontSize: "0.8rem",
                  textTransform: "none",
                  py: 0.65,
                  px: 1.4,
                  '&:hover': {
                    borderColor: '#0D9488',
                    bgcolor: isLight ? "rgba(13, 148, 136, 0.15)" : "rgba(76, 161, 175, 0.22)",
                  }
                }}
              >
                User Example
              </Button>

              <Button
                size="small"
                variant="contained"
                startIcon={<AddIcon sx={{ fontSize: 17 }} />}
                onClick={() => navigate('/admin/add-song')}
                sx={{
                  borderRadius: "8px",
                  background: "linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)",
                  color: "#FFFFFF",
                  fontWeight: 700,
                  fontSize: "0.82rem",
                  textTransform: "none",
                  py: 0.65,
                  px: 1.6,
                  boxShadow: "0 2px 8px rgba(13, 148, 136, 0.25)",
                  '&:hover': {
                    background: "linear-gradient(135deg, #0F766E 0%, #0D9488 100%)",
                  }
                }}
              >
                Add Song
              </Button>

              <Button
                size="small"
                variant="outlined"
                startIcon={<UploadIcon sx={{ fontSize: 16 }} />}
                onClick={handleDialogOpen}
                sx={{
                  borderRadius: "8px",
                  borderColor: isLight ? "#CBD5E1" : "rgba(255, 255, 255, 0.2)",
                  color: isLight ? "#475569" : "rgba(255, 255, 255, 0.8)",
                  fontWeight: 700,
                  fontSize: "0.8rem",
                  textTransform: "none",
                  py: 0.65,
                  px: 1.4,
                  '&:hover': { borderColor: '#0D9488', color: '#0D9488' }
                }}
              >
                Import PDF
              </Button>

              <Button
                size="small"
                variant="outlined"
                startIcon={<UploadFileIcon sx={{ fontSize: 16 }} />}
                onClick={() => {
                  setOpenCsvDialog(true);
                  setCsvFile(null);
                  setCsvPreviewData([]);
                }}
                sx={{
                  borderRadius: "8px",
                  borderColor: isLight ? "#CBD5E1" : "rgba(255, 255, 255, 0.2)",
                  color: isLight ? "#475569" : "rgba(255, 255, 255, 0.8)",
                  fontWeight: 700,
                  fontSize: "0.8rem",
                  textTransform: "none",
                  py: 0.65,
                  px: 1.4,
                  '&:hover': { borderColor: '#0D9488', color: '#0D9488' }
                }}
              >
                Import CSV
              </Button>

              <Button
                size="small"
                variant="outlined"
                startIcon={<VisibilityIcon sx={{ fontSize: 16 }} />}
                onClick={() => navigate('/admin/pdf-songs')}
                sx={{
                  borderRadius: "8px",
                  borderColor: isLight ? "#CBD5E1" : "rgba(255, 255, 255, 0.2)",
                  color: isLight ? "#475569" : "rgba(255, 255, 255, 0.8)",
                  fontWeight: 700,
                  fontSize: "0.8rem",
                  textTransform: "none",
                  py: 0.65,
                  px: 1.4,
                  '&:hover': { borderColor: '#0D9488', color: '#0D9488' }
                }}
              >
                View PDFs
              </Button>

              <Button
                size="small"
                variant={filterActiveTab === "archived" ? "contained" : "outlined"}
                startIcon={<InventoryIcon sx={{ fontSize: 16 }} />}
                onClick={() => setFilterActiveTab(filterActiveTab === "archived" ? "all" : "archived")}
                sx={{
                  borderRadius: "8px",
                  borderColor: isLight ? "#CBD5E1" : "rgba(255, 255, 255, 0.2)",
                  bgcolor: filterActiveTab === "archived" ? "#0D9488" : "transparent",
                  color: filterActiveTab === "archived" ? "#FFFFFF" : (isLight ? "#475569" : "rgba(255, 255, 255, 0.8)"),
                  fontWeight: 700,
                  fontSize: "0.8rem",
                  textTransform: "none",
                  py: 0.65,
                  px: 1.4,
                  '&:hover': {
                    bgcolor: filterActiveTab === "archived" ? "#0F766E" : undefined,
                    borderColor: '#0D9488',
                    color: filterActiveTab === "archived" ? "#FFFFFF" : '#0D9488'
                  }
                }}
              >
                Archived ({archivedList.length})
              </Button>
            </Box>
          </Box>

          {/* Row 2: Source Collection Pills (like Daily Devotions) & View Mode Switcher */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 1.2,
              pt: 0.8,
              borderTop: isLight ? "1px solid #F1F5F9" : "1px solid rgba(255, 255, 255, 0.08)",
            }}
          >
            {/* Pill Tabs for Collections/Sections */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, flexWrap: "wrap", overflowX: "auto", py: 0.2 }}>
              {["All", ...songCollectionGroups.map(g => g.name)].map((tabName) => {
                const count = tabName === "All" ? displayedSongs.length : (songCollectionGroups.find(g => g.name === tabName)?.count || 0);
                const isActive = activeSourceTab === tabName;
                return (
                  <Box
                    key={tabName}
                    onClick={() => {
                      setActiveSourceTab(tabName);
                      setPage(1);
                    }}
                    sx={{
                      px: 1.5,
                      py: 0.4,
                      borderRadius: 20,
                      cursor: "pointer",
                      fontSize: "0.78rem",
                      fontWeight: 700,
                      userSelect: "none",
                      transition: "all 0.2s ease",
                      display: "flex",
                      alignItems: "center",
                      gap: 0.6,
                      ...(isActive
                        ? {
                            background: "linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)",
                            color: "#FFFFFF",
                            boxShadow: "0 2px 8px rgba(13, 148, 136, 0.4)",
                          }
                        : {
                            background: isLight ? "#F1F5F9" : "rgba(255,255,255,0.06)",
                            color: isLight ? "#475569" : "rgba(255,255,255,0.7)",
                            border: isLight ? "1px solid #CBD5E1" : "1px solid rgba(255,255,255,0.12)",
                            "&:hover": {
                              background: isLight ? "#E2E8F0" : "rgba(76,161,175,0.15)",
                              color: isLight ? "#0D9488" : "#64d2e2",
                            },
                          }),
                    }}
                  >
                    <span>{tabName}</span>
                    {count > 0 && (
                      <Box
                        component="span"
                        sx={{
                          px: 0.7,
                          py: 0.1,
                          borderRadius: 10,
                          fontSize: "0.68rem",
                          fontWeight: 800,
                          backgroundColor: isActive ? "rgba(255,255,255,0.25)" : (isLight ? "rgba(0,0,0,0.08)" : "rgba(255,255,255,0.1)"),
                        }}
                      >
                        {count}
                      </Box>
                    )}
                  </Box>
                );
              })}

              {/* Add New Song Collection Pill Button */}
              <Box
                onClick={() => setNewSectionModalOpen(true)}
                sx={{
                  px: 1.4,
                  py: 0.35,
                  borderRadius: 20,
                  cursor: "pointer",
                  fontSize: "0.76rem",
                  fontWeight: 700,
                  border: isLight ? "1.5px dashed #0D9488" : "1.5px dashed #2DD4BF",
                  color: isLight ? "#0D9488" : "#2DD4BF",
                  bgcolor: isLight ? "rgba(13, 148, 136, 0.06)" : "rgba(45, 212, 191, 0.08)",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.4,
                  transition: "all 0.2s ease",
                  userSelect: "none",
                  "&:hover": {
                    bgcolor: isLight ? "rgba(13, 148, 136, 0.16)" : "rgba(45, 212, 191, 0.18)",
                    transform: "translateY(-1px)",
                  }
                }}
              >
                <AddIcon sx={{ fontSize: 14 }} />
                <span>+ New Collection</span>
              </Box>
            </Box>

            {/* View Mode Toggle (Cards vs Table) when on 'All' */}
            {filterActiveTab !== "archived" && activeSourceTab === "All" && (
              <Box display="flex" alignItems="center" gap={0.5} sx={{ bgcolor: isLight ? "#F1F5F9" : "rgba(255,255,255,0.04)", p: 0.4, borderRadius: 2, border: isLight ? "1px solid #CBD5E1" : "1px solid rgba(255,255,255,0.08)" }}>
                <Tooltip title="View Collection Cards">
                  <IconButton
                    size="small"
                    onClick={() => setAllViewMode("cards")}
                    sx={{
                      bgcolor: allViewMode === "cards" ? "#0D9488" : "transparent",
                      color: allViewMode === "cards" ? "#FFFFFF" : (isLight ? "#64748B" : "rgba(255,255,255,0.6)"),
                      borderRadius: 1.5,
                      p: 0.6,
                      "&:hover": { bgcolor: allViewMode === "cards" ? "#0F766E" : (isLight ? "#E2E8F0" : "rgba(76,161,175,0.15)") }
                    }}
                  >
                    <ViewModuleIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                <Tooltip title="View All Songs Table">
                  <IconButton
                    size="small"
                    onClick={() => setAllViewMode("table")}
                    sx={{
                      bgcolor: allViewMode === "table" ? "#0D9488" : "transparent",
                      color: allViewMode === "table" ? "#FFFFFF" : (isLight ? "#64748B" : "rgba(255,255,255,0.6)"),
                      borderRadius: 1.5,
                      p: 0.6,
                      "&:hover": { bgcolor: allViewMode === "table" ? "#0F766E" : (isLight ? "#E2E8F0" : "rgba(76,161,175,0.15)") }
                    }}
                  >
                    <ViewListIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
          </Box>
        </Paper>

        {/* View 1: Collection Cards Grid View (When activeSourceTab === 'All' && allViewMode === 'cards' && not archived) */}
        {filterActiveTab !== "archived" && activeSourceTab === "All" && allViewMode === "cards" ? (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" },
              gap: 2.5,
              mb: 3,
            }}
          >
            {songCollectionGroups.map((group) => {
              const latestTitle = group.latest?.title || group.latest?.songs?.title || "No songs added yet";
              const latestAuthor = group.latest?.author || group.latest?.songs?.author || "";
              const latestLang = group.latest ? getSongLanguage(group.latest) : "";

              return (
                <Card
                  key={group.name}
                  sx={{
                    borderRadius: "16px",
                    background: isLight ? "#FFFFFF" : "rgba(21, 34, 46, 0.75)",
                    border: isLight ? "1.5px solid #CBD5E1" : "1px solid rgba(76, 161, 175, 0.25)",
                    boxShadow: isLight ? "0 4px 16px rgba(15, 23, 42, 0.05)" : "0 8px 24px rgba(0, 0, 0, 0.2)",
                    transition: "all 0.25s ease",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    overflow: "hidden",
                    "&:hover": {
                      transform: "translateY(-3px)",
                      borderColor: "#0D9488",
                      boxShadow: "0 12px 28px rgba(13, 148, 136, 0.2)",
                    }
                  }}
                >
                  <CardContent sx={{ p: 2.5, flexGrow: 1, display: "flex", flexDirection: "column" }}>
                    {/* Header Row: Thumbnail + Collection Name + Count Badge */}
                    <Box display="flex" alignItems="flex-start" gap={1.8} mb={2}>
                      <Avatar
                        variant="rounded"
                        sx={{
                          width: 52,
                          height: 52,
                          borderRadius: "12px",
                          bgcolor: "rgba(13, 148, 136, 0.2)",
                          color: "#0D9488",
                          border: "1px solid rgba(13, 148, 136, 0.3)",
                          boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                          flexShrink: 0
                        }}
                      >
                        <LibraryMusicIcon sx={{ fontSize: 26 }} />
                      </Avatar>
                      <Box flexGrow={1} minWidth={0}>
                        <Box display="flex" alignItems="center" justifyContent="space-between" gap={1} flexWrap="wrap" mb={0.4}>
                          <Typography
                            variant="h6"
                            fontWeight={800}
                            noWrap
                            sx={{
                              color: isLight ? "#0F172A" : "#FFFFFF",
                              fontSize: "1.05rem",
                              letterSpacing: "-0.2px"
                            }}
                            title={group.name}
                          >
                            {group.name}
                          </Typography>
                          <Chip
                            size="small"
                            label={`${group.count} ${group.count === 1 ? 'song' : 'songs'}`}
                            sx={{
                              bgcolor: "rgba(13, 148, 136, 0.18)",
                              color: isLight ? "#0D9488" : "#2DD4BF",
                              fontWeight: 700,
                              fontSize: "0.72rem",
                              height: 22,
                              borderRadius: "6px"
                            }}
                          />
                        </Box>
                        <Typography variant="caption" sx={{ color: isLight ? "#64748B" : "rgba(255, 255, 255, 0.55)", fontSize: "0.75rem", display: "block" }}>
                          {group.description}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Middle: Latest Song Summary */}
                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: "10px",
                        bgcolor: isLight ? "#F8FAFC" : "rgba(255, 255, 255, 0.03)",
                        border: isLight ? "1px solid #E2E8F0" : "1px solid rgba(255, 255, 255, 0.06)",
                        mb: 2,
                        flexGrow: 1
                      }}
                    >
                      <Typography variant="caption" sx={{ color: "#0D9488", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.5px", fontSize: "0.68rem", display: "block", mb: 0.5 }}>
                        Latest Song
                      </Typography>
                      <Typography
                        variant="body2"
                        fontWeight={700}
                        sx={{
                          color: isLight ? "#1E293B" : "#E2E8F0",
                          fontSize: "0.86rem",
                          lineHeight: 1.3,
                          mb: 0.5,
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden"
                        }}
                      >
                        {latestTitle}
                      </Typography>
                      {group.latest && (
                        <Box display="flex" alignItems="center" gap={0.5} mt={0.5}>
                          <MusicNoteIcon sx={{ fontSize: 13, color: isLight ? "#64748B" : "rgba(255, 255, 255, 0.45)" }} />
                          <Typography variant="caption" sx={{ color: isLight ? "#64748B" : "rgba(255, 255, 255, 0.5)", fontSize: "0.73rem" }}>
                            {latestLang} {latestAuthor ? `• By ${latestAuthor}` : ""}
                          </Typography>
                        </Box>
                      )}
                    </Box>

                    {/* Actions: View Songs + Add Song Under this + Mobile Preview */}
                    <Box display="flex" gap={1} mt="auto">
                      <Button
                        fullWidth
                        variant="contained"
                        size="small"
                        endIcon={<ArrowForwardIcon sx={{ fontSize: 16 }} />}
                        onClick={() => {
                          setActiveSourceTab(group.name);
                          setSongCategoryTab("all");
                          setPage(1);
                        }}
                        sx={{
                          background: "linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)",
                          color: "#FFFFFF",
                          borderRadius: "8px",
                          textTransform: "none",
                          fontWeight: 700,
                          fontSize: "0.8rem",
                          py: 0.7,
                          "&:hover": { background: "linear-gradient(135deg, #0F766E 0%, #0D9488 100%)" }
                        }}
                      >
                        View Songs
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon sx={{ fontSize: 16 }} />}
                        onClick={() => navigate(`/admin/add-song?section=${encodeURIComponent(group.name)}`)}
                        sx={{
                          color: isLight ? "#0D9488" : "#2DD4BF",
                          borderColor: isLight ? "rgba(13, 148, 136, 0.4)" : "rgba(76, 161, 175, 0.4)",
                          borderRadius: "8px",
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.8rem",
                          px: 1.5,
                          py: 0.7,
                          whiteSpace: "nowrap",
                          "&:hover": {
                            borderColor: "#0D9488",
                            backgroundColor: "rgba(13, 148, 136, 0.15)"
                          }
                        }}
                      >
                        + Add
                      </Button>
                      <Tooltip title="Preview on Mobile Screen">
                        <IconButton
                          size="small"
                          onClick={() => setMobileExampleOpen(true)}
                          sx={{
                            color: isLight ? "#0D9488" : "#2DD4BF",
                            border: isLight ? "1px solid rgba(13, 148, 136, 0.35)" : "1px solid rgba(76, 161, 175, 0.4)",
                            borderRadius: "8px",
                            px: 1,
                            py: 0.7,
                            "&:hover": {
                              borderColor: "#0D9488",
                              backgroundColor: "rgba(13, 148, 136, 0.15)"
                            }
                          }}
                        >
                          <PhoneIphoneIcon sx={{ fontSize: 17 }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </CardContent>
                </Card>
              );
            })}

            {/* Dashed Add New Song Collection Card */}
            <Card
              onClick={() => setNewSectionModalOpen(true)}
              sx={{
                borderRadius: "16px",
                background: isLight ? "#F8FAFC" : "rgba(21, 34, 46, 0.4)",
                border: isLight ? "2px dashed #94A3B8" : "2px dashed rgba(76, 161, 175, 0.4)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                p: 3,
                textAlign: "center",
                cursor: "pointer",
                minHeight: 220,
                transition: "all 0.25s ease",
                "&:hover": {
                  borderColor: "#0D9488",
                  background: isLight ? "#F0FDFA" : "rgba(13, 148, 136, 0.15)",
                  transform: "translateY(-3px)",
                }
              }}
            >
              <Box
                sx={{
                  width: 54,
                  height: 54,
                  borderRadius: "50%",
                  bgcolor: "rgba(13, 148, 136, 0.2)",
                  color: "#0D9488",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 1.5,
                  boxShadow: "0 4px 14px rgba(13, 148, 136, 0.25)"
                }}
              >
                <AddIcon sx={{ fontSize: 30 }} />
              </Box>
              <Typography variant="h6" fontWeight={800} sx={{ color: isLight ? "#0F172A" : "#FFFFFF", fontSize: "1rem", mb: 0.5 }}>
                Add New Song Collection
              </Typography>
              <Typography variant="body2" sx={{ color: isLight ? "#64748B" : "rgba(255, 255, 255, 0.6)", fontSize: "0.78rem", mb: 2, maxWidth: 220 }}>
                Create a new song collection/section and publish songs under it.
              </Typography>
              <Button
                variant="contained"
                size="small"
                startIcon={<AddIcon />}
                sx={{
                  background: "linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)",
                  color: "#FFFFFF",
                  borderRadius: "8px",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: "0.78rem",
                  px: 2,
                  pointerEvents: "none"
                }}
              >
                + Create Song Collection
              </Button>
            </Card>
          </Box>
        ) : (
          <>
            {/* Inside Section or Table View */}
            {activeSourceTab !== "All" && (
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2, flexWrap: "wrap", gap: 1 }}>
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<ArrowBackIcon sx={{ fontSize: 16 }} />}
                  onClick={() => {
                    setActiveSourceTab("All");
                    setAllViewMode("cards");
                  }}
                  sx={{
                    borderRadius: "8px",
                    borderColor: "#0D9488",
                    color: "#0D9488",
                    fontWeight: 700,
                    textTransform: "none",
                    fontSize: "0.8rem",
                    "&:hover": { borderColor: "#0F766E", bgcolor: "rgba(13, 148, 136, 0.08)" }
                  }}
                >
                  Back to Collections
                </Button>
                <Typography variant="subtitle1" fontWeight={800} sx={{ color: isLight ? "#0F172A" : "#FFFFFF" }}>
                  Collection: <span style={{ color: "#0D9488" }}>{activeSourceTab}</span> ({filteredBySection.length} songs)
                </Typography>
              </Box>
            )}

            {/* The 4 Sub-Tabs Bar: All, Songs, PDF Songs, Import Songs */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1.5,
                mb: 2,
                p: 1.2,
                borderRadius: "12px",
                background: isLight ? "#F8FAFC" : "rgba(255, 255, 255, 0.03)",
                border: isLight ? "1px solid #CBD5E1" : "1px solid rgba(76, 161, 175, 0.2)",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                {[
                  { key: "all", label: "All", count: filteredBySection.length, icon: <MusicNoteIcon sx={{ fontSize: 16 }} /> },
                  { key: "songs", label: "Songs", count: filteredBySection.filter(s => !s.is_imported && !s.songs?.is_imported).length, icon: <LibraryMusicIcon sx={{ fontSize: 16 }} /> },
                  { key: "pdf_songs", label: "PDF Songs", count: pdfSongs.length, icon: <PictureAsPdfIcon sx={{ fontSize: 16 }} /> },
                  { key: "import_songs", label: "Import Songs", count: filteredBySection.filter(s => s.is_imported || s.songs?.is_imported).length, icon: <UploadFileIcon sx={{ fontSize: 16 }} /> }
                ].map(tab => (
                  <Button
                    key={tab.key}
                    size="small"
                    variant={songCategoryTab === tab.key ? "contained" : "outlined"}
                    startIcon={tab.icon}
                    onClick={() => setSongCategoryTab(tab.key)}
                    sx={{
                      borderRadius: "20px",
                      textTransform: "none",
                      fontWeight: 700,
                      fontSize: "0.8rem",
                      px: 1.8,
                      py: 0.5,
                      ...(songCategoryTab === tab.key
                        ? {
                            background: "linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)",
                            color: "#FFFFFF",
                            boxShadow: "0 2px 8px rgba(13, 148, 136, 0.35)",
                            borderColor: "transparent"
                          }
                        : {
                            borderColor: isLight ? "#CBD5E1" : "rgba(255, 255, 255, 0.15)",
                            color: isLight ? "#475569" : "rgba(255, 255, 255, 0.7)",
                            bgcolor: isLight ? "#FFFFFF" : "rgba(255, 255, 255, 0.04)",
                            "&:hover": {
                              borderColor: "#0D9488",
                              color: "#0D9488",
                              bgcolor: isLight ? "rgba(13, 148, 136, 0.08)" : "rgba(76, 161, 175, 0.15)"
                            }
                          })
                    }}
                  >
                    <span>{tab.label}</span>
                    <Box
                      component="span"
                      sx={{
                        ml: 0.8,
                        px: 0.7,
                        py: 0.1,
                        borderRadius: "10px",
                        fontSize: "0.7rem",
                        fontWeight: 800,
                        bgcolor: songCategoryTab === tab.key ? "rgba(255,255,255,0.25)" : (isLight ? "rgba(0,0,0,0.06)" : "rgba(255,255,255,0.1)"),
                        color: songCategoryTab === tab.key ? "#FFFFFF" : (isLight ? "#475569" : "rgba(255,255,255,0.8)")
                      }}
                    >
                      {tab.count}
                    </Box>
                  </Button>
                ))}
              </Box>

              {/* Tab Context Action Button */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {songCategoryTab === "pdf_songs" && (
                  <Button
                    size="small"
                    variant="contained"
                    startIcon={<UploadIcon sx={{ fontSize: 16 }} />}
                    onClick={handleDialogOpen}
                    sx={{
                      borderRadius: "8px",
                      background: "linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)",
                      color: "#FFFFFF",
                      fontWeight: 700,
                      fontSize: "0.8rem",
                      textTransform: "none",
                      py: 0.6,
                      px: 1.5
                    }}
                  >
                    Upload PDF Song
                  </Button>
                )}
                {songCategoryTab === "import_songs" && (
                  <Button
                    size="small"
                    variant="contained"
                    startIcon={<UploadFileIcon sx={{ fontSize: 16 }} />}
                    onClick={() => {
                      setOpenCsvDialog(true);
                      setCsvFile(null);
                      setCsvPreviewData([]);
                    }}
                    sx={{
                      borderRadius: "8px",
                      background: "linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)",
                      color: "#FFFFFF",
                      fontWeight: 700,
                      fontSize: "0.8rem",
                      textTransform: "none",
                      py: 0.6,
                      px: 1.5
                    }}
                  >
                    Upload CSV File
                  </Button>
                )}
                {songCategoryTab === "songs" && (
                  <Button
                    size="small"
                    variant="contained"
                    startIcon={<AddIcon sx={{ fontSize: 16 }} />}
                    onClick={() => navigate('/admin/add-song')}
                    sx={{
                      borderRadius: "8px",
                      background: "linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)",
                      color: "#FFFFFF",
                      fontWeight: 700,
                      fontSize: "0.8rem",
                      textTransform: "none",
                      py: 0.6,
                      px: 1.5
                    }}
                  >
                    Add Song
                  </Button>
                )}
              </Box>
            </Box>

            {/* Opened Collection Filters: Type, Language, Organization, Display */}
            {songCategoryTab !== "pdf_songs" && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1.2,
                  mb: 2,
                  p: 1.2,
                  borderRadius: "10px",
                  bgcolor: isLight ? "#F8FAFC" : "rgba(255, 255, 255, 0.03)",
                  border: isLight ? "1px solid #CBD5E1" : "1px solid rgba(76, 161, 175, 0.2)",
                }}
              >
                {/* Song Type (Default vs My Songs) */}
                <FormControl size="small" sx={{ minWidth: 140 }}>
                  <InputLabel sx={{ color: isLight ? '#475569' : undefined, fontWeight: 700, fontSize: "0.82rem" }}>
                    Type
                  </InputLabel>
                  <Select
                    value={songType}
                    label="Type"
                    onChange={(e) => { setSongType(e.target.value); setPage(1); }}
                    sx={{
                      borderRadius: "8px",
                      bgcolor: isLight ? "#FFFFFF" : "rgba(255, 255, 255, 0.05)",
                      color: isLight ? "#0F172A" : "#FFFFFF",
                      fontWeight: 600,
                      fontSize: "0.82rem",
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: isLight ? '#CBD5E1' : 'rgba(255, 255, 255, 0.15)' },
                      '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#0D9488' },
                    }}
                  >
                    <MenuItem value="1" sx={{ fontWeight: 600 }}>Default Songs</MenuItem>
                    <MenuItem value="2" sx={{ fontWeight: 600 }}>My Songs</MenuItem>
                  </Select>
                </FormControl>

                {/* Language */}
                <FormControl size="small" sx={{ minWidth: 140 }}>
                  <InputLabel sx={{ color: isLight ? '#475569' : undefined, fontWeight: 700, fontSize: "0.82rem" }}>
                    Language
                  </InputLabel>
                  <Select
                    value={language}
                    label="Language"
                    onChange={(e) => { setLanguage(e.target.value); setPage(1); }}
                    sx={{
                      borderRadius: "8px",
                      bgcolor: isLight ? "#FFFFFF" : "rgba(255, 255, 255, 0.05)",
                      color: isLight ? "#0F172A" : "#FFFFFF",
                      fontWeight: 600,
                      fontSize: "0.82rem",
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: isLight ? '#CBD5E1' : 'rgba(255, 255, 255, 0.15)' },
                      '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#0D9488' },
                    }}
                  >
                    <MenuItem value="All Languages" sx={{ fontWeight: 600 }}>All Languages</MenuItem>
                    <MenuItem value="1">English</MenuItem>
                    <MenuItem value="2">Telugu</MenuItem>
                    <MenuItem value="3">Hindi</MenuItem>
                  </Select>
                </FormControl>

                {/* Organization filter (Super Admin only) */}
                {user?.role === 1 && !isOrgSwitched && (
                  <Autocomplete
                    size="small"
                    value={organization}
                    onChange={(event, newValue) => {
                      setOrganization(newValue);
                      setPage(1);
                    }}
                    options={orgOptions}
                    getOptionLabel={(option) => option?.org_name || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Organization"
                        InputLabelProps={{ sx: { color: isLight ? '#475569' : undefined, fontWeight: 700, fontSize: "0.82rem" } }}
                      />
                    )}
                    sx={{
                      width: 170,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: "8px",
                        bgcolor: isLight ? "#FFFFFF" : "rgba(255, 255, 255, 0.05)",
                        color: isLight ? "#0F172A" : "#FFFFFF",
                        fontWeight: 600,
                        fontSize: "0.82rem",
                        '& fieldset': { borderColor: isLight ? '#CBD5E1' : 'rgba(255, 255, 255, 0.15)' },
                        '&:hover fieldset': { borderColor: '#0D9488' },
                      }
                    }}
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                  />
                )}

                {/* Non-SA Song Display Radio Options (inline, short & compact) */}
                {user?.role != 1 && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, ml: { xs: 0, md: "auto" } }}>
                    <Typography variant="caption" sx={{ fontWeight: 700, color: isLight ? "#475569" : "rgba(255,255,255,0.7)" }}>
                      Display:
                    </Typography>
                    <RadioGroup
                      row
                      value={DisplayType}
                      onChange={(e) => setDisplayType(e.target.value)}
                      sx={{ gap: 0.5 }}
                    >
                      <FormControlLabel value="Song" control={<Radio size="small" />} label={<Typography variant="caption" fontWeight={600}>Songs</Typography>} />
                      <FormControlLabel value="Pdf" control={<Radio size="small" />} label={<Typography variant="caption" fontWeight={600}>PDFs</Typography>} />
                      <FormControlLabel value="Both" control={<Radio size="small" />} label={<Typography variant="caption" fontWeight={600}>Both</Typography>} />
                    </RadioGroup>
                    <Button size="small" variant="contained" onClick={handleSongsSettings} sx={{ py: 0.3, px: 1.2, fontSize: "0.75rem", borderRadius: "6px", bgcolor: "#0D9488", textTransform: "none", fontWeight: 700 }}>
                      Save
                    </Button>
                  </Box>
                )}
              </Box>
            )}

            {/* PDF Songs View */}
            {songCategoryTab === "pdf_songs" ? (
              <Paper elevation={0} sx={{ p: 2.5, borderRadius: "12px", border: isLight ? "1px solid #CBD5E1" : "1px solid rgba(76, 161, 175, 0.25)" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2.5, flexWrap: "wrap", gap: 1 }}>
                  <TextField
                    size="small"
                    placeholder="Filter PDF songs..."
                    value={pdfSearch}
                    onChange={(e) => setPdfSearch(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon sx={{ color: isLight ? "#64748B" : "rgba(255,255,255,0.5)", fontSize: 18 }} />
                        </InputAdornment>
                      )
                    }}
                    sx={{ maxWidth: 320 }}
                  />
                  <Typography variant="body2" color="text.secondary">
                    Showing {pdfSongs.filter(p => !pdfSearch || (p.title || '').toLowerCase().includes(pdfSearch.toLowerCase())).length} PDF songbooks
                  </Typography>
                </Box>

                {loadingPdfs ? (
                  <SectionLoader open={loadingPdfs} />
                ) : pdfSongs.filter(p => !pdfSearch || (p.title || '').toLowerCase().includes(pdfSearch.toLowerCase())).length === 0 ? (
                  <Box sx={{ textAlign: "center", py: 6 }}>
                    <PictureAsPdfIcon sx={{ fontSize: 48, color: "text.disabled", mb: 1.5 }} />
                    <Typography variant="h6" fontWeight={700}>No PDF Songs Found</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                      Upload your first PDF songbook to make it available to users.
                    </Typography>
                    <Button
                      variant="contained"
                      startIcon={<UploadIcon />}
                      onClick={handleDialogOpen}
                      sx={{ bgcolor: "#0D9488", textTransform: "none", fontWeight: 700 }}
                    >
                      Upload PDF Song
                    </Button>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(4, 1fr)" },
                      gap: 2
                    }}
                  >
                    {pdfSongs
                      .filter(p => !pdfSearch || (p.title || '').toLowerCase().includes(pdfSearch.toLowerCase()))
                      .map(pdf => (
                        <Card
                          key={pdf.id}
                          variant="outlined"
                          sx={{
                            borderRadius: "12px",
                            p: 2,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            transition: "all 0.2s ease",
                            '&:hover': {
                              borderColor: "#0D9488",
                              transform: "translateY(-2px)",
                              boxShadow: "0 6px 16px rgba(0,0,0,0.1)"
                            }
                          }}
                        >
                          <Box>
                            <Box display="flex" alignItems="center" gap={1.2} mb={1.2}>
                              <Avatar sx={{ bgcolor: "rgba(239, 68, 68, 0.15)", color: "#EF4444", borderRadius: "8px" }}>
                                <PictureAsPdfIcon />
                              </Avatar>
                              <Box minWidth={0} flexGrow={1}>
                                <Typography variant="subtitle2" fontWeight={800} noWrap title={pdf.title}>
                                  {pdf.title}
                                </Typography>
                                <Typography variant="caption" color="text.secondary" noWrap display="block">
                                  {pdf.origanisation?.org_name || "GPN Songbook"}
                                </Typography>
                              </Box>
                            </Box>
                            {pdf.created_at && (
                              <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 1.5 }}>
                                Uploaded: {new Date(pdf.created_at).toLocaleDateString()}
                              </Typography>
                            )}
                          </Box>

                          <Box display="flex" gap={1} mt={1}>
                            <Button
                              fullWidth
                              size="small"
                              variant="contained"
                              startIcon={<VisibilityIcon sx={{ fontSize: 15 }} />}
                              onClick={() => setSelectedPdfUrl(pdf.song_url)}
                              sx={{
                                bgcolor: "#0D9488",
                                textTransform: "none",
                                fontWeight: 700,
                                fontSize: "0.78rem",
                                '&:hover': { bgcolor: "#0F766E" }
                              }}
                            >
                              View PDF
                            </Button>
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleDeletePdf(pdf.id)}
                              sx={{ border: "1px solid rgba(239, 68, 68, 0.3)", borderRadius: "6px" }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </Card>
                      ))}
                  </Box>
                )}
              </Paper>
            ) : (
              /* Standard Songs Table for All, Songs, and Import Songs */
              <Paper>
                <TableContainer sx={{ display: { xs: 'none', md: 'block' } }}>
                  <Table>
                    <TableHead>
                      <TableRow >
                        {songType === '1' && user?.role !== 1 && (
                          <TableCell padding="checkbox">
                            <Box display="flex" alignItems="center">
                              <Checkbox
                                checked={selected.length === songs.length}
                                indeterminate={selected.length > 0 && selected.length < songs.length}
                                onChange={handleSelectAll}
                              />
                              <IconButton size="small" onClick={handleMenuOpen} data-testid="dropdown-btn">
                                <ArrowDropDownIcon />
                              </IconButton>

                              <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleMenuClose}
                              >
                                <MenuItem onClick={() => { handleSelectOption(1); handleMenuClose(); }}>
                                  Add to My Songs
                                </MenuItem>
                                <MenuItem onClick={() => { handleSelectOption(2); handleMenuClose(); }}>
                                  Remove from My Songs
                                </MenuItem>
                              </Menu>
                            </Box>
                          </TableCell>
                        )}
                        <TableCell>Song</TableCell>
                        <TableCell>Language</TableCell>
                        <TableCell>Author</TableCell>
                        {user?.role === 1 && (
                          <TableCell>ORGANIZATION</TableCell>
                        )}
                        <TableCell>STATUS</TableCell>
                        <TableCell>ACTIONS</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {loading && <SectionLoader open={loading} />}

                      {finalTabSongs.length > 0 ? (
                        finalTabSongs.map((song) => (
                    <TableRow
                      key={song.id}
                      hover
                      data-testid={`song-row-${song.id}`}
                      onClick={() => {
                        setSelectedSongForView(song);
                        setSongDetailModalOpen(true);
                      }}
                      sx={{
                        cursor: 'pointer',
                        transition: 'background-color 0.15s ease',
                        '&:hover': {
                          bgcolor: isLight ? '#F0FDFA !important' : 'rgba(13, 148, 136, 0.1) !important',
                        },
                        '& td': {
                          borderBottom: isLight ? '1px solid #E2E8F0' : '1px solid rgba(255,255,255,0.06)',
                          py: 1.5,
                          color: isLight ? '#1E293B' : '#F1F5F9',
                        }
                      }}
                    >

                      {songType === '1' && user?.role !== 1 && (
                        <TableCell padding="checkbox" onClick={(e) => e.stopPropagation()}>
                          <Checkbox
                            data-testid={`checkbox-${song.id}`}
                            checked={
                              // If already added – checked
                              song.is_added === 1
                                ? true
                                : selected.includes(song.id)
                            }
                            onChange={() => handleSelect(song.id, song.title)}
                          />
                        </TableCell>
                      )}

                      <TableCell>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                            <Avatar
                              src={song.image || song.songs?.image || undefined}
                              sx={{
                                width: 42,
                                height: 42,
                                borderRadius: 2,
                                background: "linear-gradient(135deg, #203A43 0%, #2C5364 100%)",
                                color: "#4CA1AF",
                                fontWeight: 700,
                                fontSize: 18,
                                border: "1px solid rgba(76, 161, 175, 0.3)",
                              }}
                              imgProps={{
                                onError: (e) => { e.target.onerror = null; e.target.src = ""; }
                              }}
                            >
                              {(song.title || song.songs?.title) ? (song.title?.[0] || song.songs?.title?.[0]).toUpperCase() : <MusicNoteIcon sx={{ fontSize: 22 }} />}
                            </Avatar>

                          </Box>
                          <Box>
                            <Typography fontWeight={600}>{song?.role}
                              {song.title || song.songs?.title}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {song.song?.slice(0, 30) || song.songs?.song?.slice(0, 30)}....
                            </Typography>

                          </Box>
                        </Box>
                      </TableCell>



                      <TableCell>{getSongLanguage(song)}</TableCell>

                      <TableCell>{song.author ?? song.songs?.author ?? ''}</TableCell>


                      {Number(user?.role) === 1 && (
                        <TableCell>{song?.origanisation?.org_name}</TableCell>
                      )}


                      <TableCell>
                        <Chip
                          label={
                            (song?.status === 1 || song?.songs?.status === 1)
                              ? "Active"
                              : "Inactive"
                          }
                          color={statusColors[song?.status ?? song?.songs?.status] || "default"}
                          size="small"
                          sx={{ fontWeight: 600 }}
                        />
                      </TableCell>

                      <TableCell onClick={(e) => e.stopPropagation()}>
                        {filterActiveTab === "archived" ? (
                          <Box display="flex" alignItems="center" gap={0.5}>
                            <Tooltip title="Restore Song (Show in mobile app)">
                              <IconButton
                                size="small"
                                onClick={() => handleRestore(song.id)}
                                sx={{ color: '#10B981', '&:hover': { background: 'rgba(16, 185, 129, 0.1)' } }}
                              >
                                <UnarchiveIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Permanently Delete">
                              <IconButton
                                size="small"
                                onClick={() => handlePermanentDelete(song.id)}
                                sx={{ color: '#EF4444', '&:hover': { background: 'rgba(239, 68, 68, 0.1)' } }}
                              >
                                <DeleteForeverIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        ) : (() => {
                          // ------- SONG TYPE 2: My Songs -------
                          if (songType === '2') {
                            const s = song?.songs; // safe shortcut
                            if (!s) return null;

                            const isOwnSong = Number(user.org_id) === Number(s?.org_id);
                            const isActive = s?.status === 1;

                            // Allow only if song is ACTIVE
                            const canEditOrDelete =
                              isActive && (Number(user.role) === 1 || isOwnSong);

                            if (canEditOrDelete) {
                              return (
                                <Box display="flex" alignItems="center" gap={0.5}>
                                  <IconButton
                                    title="Edit"
                                    onClick={() => handleEdit(s.id)}
                                    sx={{ color: '#4CA1AF', '&:hover': { background: 'rgba(76, 161, 175, 0.1)' } }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>

                                  <Tooltip title="Archive Song (Hide from mobile app)">
                                    <IconButton
                                      size="small"
                                      onClick={() => handleArchive(s)}
                                      sx={{ color: '#F59E0B', '&:hover': { background: 'rgba(245, 158, 11, 0.1)' } }}
                                    >
                                      <ArchiveIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>

                                  <IconButton
                                    size="small"
                                    aria-label="delete"
                                    data-testid={`delete-btn-${s.id}`}
                                    onClick={() => handleDelete(s.id)}
                                    sx={{ color: '#EF4444', '&:hover': { background: 'rgba(239, 68, 68, 0.1)' } }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              );
                            }
                          }

                          // ------- SONG TYPE 1: Default Songs -------
                          if (songType === '1') {
                            const isActive = song?.status === 1;

                            if (Number(user.role) === 1 && isActive) {
                              return (
                                <Box display="flex" alignItems="center" gap={0.5}>
                                  <IconButton
                                    title="Edit"
                                    onClick={() => handleEdit(song.id)}
                                    sx={{ color: '#4CA1AF', '&:hover': { background: 'rgba(76, 161, 175, 0.1)' } }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>

                                  <Tooltip title="Archive Song (Hide from mobile app)">
                                    <IconButton
                                      size="small"
                                      onClick={() => handleArchive(song)}
                                      sx={{ color: '#F59E0B', '&:hover': { background: 'rgba(245, 158, 11, 0.1)' } }}
                                    >
                                      <ArchiveIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>

                                  <IconButton
                                    size="small"
                                    aria-label="delete"
                                    data-testid={`delete-btn-${song.id}`}
                                    onClick={() => handleDelete(song.id)}
                                    sx={{ color: '#EF4444', '&:hover': { background: 'rgba(239, 68, 68, 0.1)' } }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </Box>
                              );
                            }
                          }

                          return (
                            <Tooltip title="Archive Song (Hide from mobile app)">
                              <IconButton
                                size="small"
                                onClick={() => handleArchive(song)}
                                sx={{ color: '#F59E0B', '&:hover': { background: 'rgba(245, 158, 11, 0.1)' } }}
                              >
                                <ArchiveIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          );
                        })()}
                      </TableCell>

                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} sx={{ textAlign: "center", py: 4 }}>
                      {filterActiveTab === "archived" ? "No archived songs found" : "No songs found"}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>

            </Table>
          </TableContainer>

          {/* Mobile Card View */}
          <Box sx={{ display: { xs: 'flex', md: 'none' }, flexDirection: 'column', gap: 2, p: 1, width: '100%' }}>
              {finalTabSongs.map((song) => {
                const s = songType === '2' ? song?.songs : song;
                if (!s) return null;
                return (
                  <Box key={s.id} sx={{ width: '100%' }}>
                    <Card
                      variant="outlined"
                      onClick={() => {
                        setSelectedSongForView(song);
                        setSongDetailModalOpen(true);
                      }}
                      sx={{
                        borderRadius: 2,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        cursor: 'pointer',
                        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                        '&:hover': {
                          transform: 'translateY(-2px)',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        }
                      }}
                    >
                      <CardContent sx={{ p: 3, textAlign: 'center', flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <Avatar
                          src={s.image || undefined}
                          sx={{
                            width: 60,
                            height: 60,
                            mx: 'auto',
                            mb: 2,
                            borderRadius: 2,
                            background: "linear-gradient(135deg, #203A43 0%, #2C5364 100%)",
                            color: "#4CA1AF",
                            fontWeight: 700,
                            fontSize: 22,
                            border: "1px solid rgba(76, 161, 175, 0.3)",
                          }}
                          imgProps={{
                            onError: (e) => { e.target.onerror = null; e.target.src = ""; }
                          }}
                        >
                          {s.title ? s.title[0].toUpperCase() : <MusicNoteIcon sx={{ fontSize: 32 }} />}
                        </Avatar>
                        <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                          {s.title}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                          {s.artist}
                        </Typography>

                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="caption" color="textSecondary" display="block">Category</Typography>
                            <Typography variant="body2">{s.categories?.name || "N/A"}</Typography>
                          </Box>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="caption" color="textSecondary" display="block">Status</Typography>
                            <Chip 
                              label={s.status === 1 ? "Active" : "Inactive"} 
                              size="small" 
                              color={s.status === 1 ? "success" : "default"}
                              sx={{ height: 20, fontSize: '0.65rem' }}
                            />
                          </Box>
                        </Box>

                        <Box sx={{ pt: 2, borderTop: '1px solid #E5E7EB', display: 'flex', justifyContent: 'center', gap: 1 }}>
                          {/* Reuse existing edit/delete logic simplified for mobile */}
                          {( (songType === '2' && s.status === 1 && (Number(user.role) === 1 || Number(user.org_id) === Number(s.org_id))) || 
                             (songType === '1' && Number(user.role) === 1 && s.status === 1) ) && (
                            <>
                              <IconButton onClick={() => handleEdit(s.id)} sx={{ color: '#4CA1AF' }}>
                                <EditIcon />
                              </IconButton>
                              <IconButton onClick={() => handleDelete(s.id)} sx={{ color: '#EF4444' }}>
                                <DeleteIcon />
                              </IconButton>
                            </>
                          )}
                        </Box>
                      </CardContent>
                    </Card>
                  </Box>
                );
              })}
              {finalTabSongs.length === 0 && (
                <Box sx={{ width: '100%', textAlign: 'center', py: 4 }}>
                  <Typography variant="body1" color="textSecondary">
                    No Songs found
                  </Typography>
                </Box>
              )}
          </Box>
          {/* Pagination */}
          {totalItems > 0 && (
            <>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: 2 }}>
                <Typography variant="body2">
                  Showing {page * pageSize - pageSize + 1}-{Math.min(page * pageSize, totalItems)} of {totalItems}
                </Typography>
                <Box>
                  <Button variant="outlined" sx={{ minWidth: 40, mx: 1 }} onClick={() => setPage(page - 1)} disabled={page === 1}>{'<'}</Button>
                  <Button variant="contained" sx={{ minWidth: 40, mx: 1, background: '#177373' }} onClick={() => setPage(page)}>{page}</Button>
                  <Button variant="outlined" sx={{ minWidth: 40, mx: 1 }} onClick={() => setPage(page + 1)} disabled={page === totalPages}>{'>'}</Button>
                </Box>
              </Box>
            </>
          )}
        </Paper>
            )}
          </>
        )}




        {/* Import Songs via CSV Dialog */}
        <Dialog
          open={openCsvDialog}
          onClose={() => !csvImporting && setOpenCsvDialog(false)}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <UploadFileIcon sx={{ color: '#0D9488' }} />
              <Typography variant="h6" fontWeight={700}>
                Import Songs via CSV File
              </Typography>
            </Box>
            <IconButton onClick={() => !csvImporting && setOpenCsvDialog(false)} size="small">
              <CloseIcon fontSize="small" />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
              {/* Instructions & Template Download Card */}
              <Card variant="outlined" sx={{ bgcolor: isLight ? '#F0FDFA' : 'rgba(13, 148, 136, 0.1)', borderColor: '#0D9488' }}>
                <CardContent sx={{ py: 2, '&:last-child': { pb: 2 } }}>
                  <Typography variant="subtitle2" fontWeight={700} sx={{ color: '#0F766E', mb: 0.5 }}>
                    Step 1: Download Sample CSV Template
                  </Typography>
                  <Typography variant="body2" sx={{ color: isLight ? '#334155' : 'rgba(255,255,255,0.8)', mb: 1.5, fontSize: '0.85rem' }}>
                    Download the sample template file to see the expected columns and formatting. You can add songs in English, Telugu, and Hindi. Once filled, upload it below.
                  </Typography>
                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<FileDownloadIcon />}
                    onClick={downloadSampleCsv}
                    sx={{
                      bgcolor: '#0D9488',
                      textTransform: 'none',
                      fontWeight: 700,
                      fontSize: '0.82rem',
                      '&:hover': { bgcolor: '#0F766E' }
                    }}
                  >
                    Download Sample CSV Template (.csv)
                  </Button>
                </CardContent>
              </Card>

              {/* Step 2: Upload CSV File */}
              <Box>
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1, color: isLight ? '#0F172A' : '#FFFFFF' }}>
                  Step 2: Upload Your Completed CSV File
                </Typography>

                <Box
                  sx={{
                    border: '2px dashed',
                    borderColor: csvFile ? '#0D9488' : (isLight ? '#CBD5E1' : 'rgba(255,255,255,0.2)'),
                    borderRadius: '10px',
                    p: 3,
                    textAlign: 'center',
                    bgcolor: csvFile ? (isLight ? '#F0FDFA' : 'rgba(13, 148, 136, 0.05)') : 'transparent',
                    cursor: 'pointer',
                    transition: 'all 0.2s',
                    '&:hover': { borderColor: '#0D9488' }
                  }}
                  onClick={() => document.getElementById('csv-file-upload-input').click()}
                >
                  <input
                    id="csv-file-upload-input"
                    type="file"
                    accept=".csv,text/csv"
                    style={{ display: 'none' }}
                    onChange={handleCsvFileChange}
                  />
                  <UploadFileIcon sx={{ fontSize: 40, color: '#0D9488', mb: 1 }} />
                  <Typography variant="body1" fontWeight={600} sx={{ color: isLight ? '#1E293B' : '#F1F5F9' }}>
                    {csvFile ? csvFile.name : 'Click to browse or drop your .csv file here'}
                  </Typography>
                  <Typography variant="caption" sx={{ color: isLight ? '#64748B' : 'rgba(255,255,255,0.6)' }}>
                    Supported format: .csv (Comma-Separated Values with UTF-8 encoding)
                  </Typography>
                </Box>
              </Box>

              {/* Step 3: Preview Table */}
              {csvPreviewData.length > 0 && (
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant="subtitle2" fontWeight={700} sx={{ color: '#0D9488' }}>
                      Preview: {csvPreviewData.length} song(s) ready to import
                    </Typography>
                    <Chip
                      label={`${csvPreviewData.length} Songs Detected`}
                      size="small"
                      color="primary"
                      sx={{ fontWeight: 700, fontSize: '0.75rem', bgcolor: '#0D9488' }}
                    />
                  </Box>

                  <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 220, borderRadius: '8px' }}>
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow sx={{ bgcolor: isLight ? '#F8FAFC' : 'rgba(255,255,255,0.05)' }}>
                          <TableCell sx={{ fontWeight: 700, fontSize: '0.75rem' }}>#</TableCell>
                          <TableCell sx={{ fontWeight: 700, fontSize: '0.75rem' }}>Title</TableCell>
                          <TableCell sx={{ fontWeight: 700, fontSize: '0.75rem' }}>Language</TableCell>
                          <TableCell sx={{ fontWeight: 700, fontSize: '0.75rem' }}>Author</TableCell>
                          <TableCell sx={{ fontWeight: 700, fontSize: '0.75rem' }}>Lyrics Preview</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {csvPreviewData.slice(0, 10).map((row, idx) => (
                          <TableRow key={idx}>
                            <TableCell sx={{ fontSize: '0.75rem' }}>{row.song_number || idx + 1}</TableCell>
                            <TableCell sx={{ fontSize: '0.75rem', fontWeight: 600 }}>{row.title || '-'}</TableCell>
                            <TableCell sx={{ fontSize: '0.75rem' }}>
                              <Chip
                                label={row.language || 'English'}
                                size="small"
                                variant="outlined"
                                sx={{ fontSize: '0.7rem', height: 20 }}
                              />
                            </TableCell>
                            <TableCell sx={{ fontSize: '0.75rem' }}>{row.author || 'Unknown'}</TableCell>
                            <TableCell sx={{ fontSize: '0.75rem', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {row.lyrics || row.song || '-'}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {csvPreviewData.length > 10 && (
                    <Typography variant="caption" sx={{ color: isLight ? '#64748B' : 'rgba(255,255,255,0.6)', mt: 0.5, display: 'block' }}>
                      Showing first 10 of {csvPreviewData.length} songs. All {csvPreviewData.length} songs will be imported.
                    </Typography>
                  )}
                </Box>
              )}
            </Box>
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button
              onClick={() => setOpenCsvDialog(false)}
              disabled={csvImporting}
              sx={{ textTransform: 'none', fontWeight: 600 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleImportCsvSubmit}
              disabled={csvImporting || (!csvFile && csvPreviewData.length === 0)}
              startIcon={csvImporting ? <CircularProgress size={16} color="inherit" /> : <UploadFileIcon />}
              sx={{
                bgcolor: '#0D9488',
                textTransform: 'none',
                fontWeight: 700,
                px: 2.5,
                '&:hover': { bgcolor: '#0F766E' }
              }}
            >
              {csvImporting ? 'Importing Songs...' : `Import ${csvPreviewData.length ? `${csvPreviewData.length} ` : ''}Songs`}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Import Songs */}


        <Dialog open={openDialog} onClose={handleDialogClose} fullWidth maxWidth="sm">
          <DialogTitle>Import PDF Songs</DialogTitle>
          <DialogContent>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                <TextField
                  label="Title"
                  value={eventName}
                  onChange={(e) =>
                    seteventName(e.target.value)
                  }
                  inputProps={{ 'data-testid': 'pdf-title' }}
                />
              </Box>

              <Box>
                <Typography variant="body2" sx={{ mb: 0.5 }}>Choose PDF File</Typography>

                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      Setimage({
                        file: file,
                        preview: URL.createObjectURL(file),
                      });
                    }
                  }}

                  aria-label="Choose PDF File"

                  data-testid="file-input"

                />

              </Box>


              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}></Box>
            </Box>

          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>Cancel</Button>
            <Button onClick={ImportPdfSongs} variant="contained" color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>



        <Dialog open={openViewDialog} onClose={handleDialogClose} fullWidth maxWidth="sm">
          <DialogTitle>{status === 1 ? 'Add to My List' : 'Remove from My List'}</DialogTitle>
          <DialogContent>

            {selectedSongs.length === 0 && (
              <Typography variant="body2" color="text.secondary">
                No songs selected.
              </Typography>
            )}
            {selectedSongs.map((song, index) => (

              <Typography variant="h6">{index + 1}. {song.name}</Typography>

            ))}

          </DialogContent>
          <DialogActions>
            <Button onClick={handleViewDialogClose}>Cancel</Button>
            <Button onClick={SongsaddtoOrganization} variant="contained" color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        {/* Song Detail Modal Popup */}
        <Dialog
          open={songDetailModalOpen}
          onClose={() => {
            setSongDetailModalOpen(false);
            setSelectedSongForView(null);
          }}
          fullWidth
          maxWidth="md"
          PaperProps={{
            sx: {
              borderRadius: 3,
              bgcolor: isLight ? '#FFFFFF' : '#1e293b',
              backgroundImage: 'none',
              overflow: 'hidden',
            }
          }}
        >
          {selectedSongForView && (() => {
            const currentSong = songType === '2' && selectedSongForView.songs ? selectedSongForView.songs : selectedSongForView;
            const songTitle = currentSong.title || 'Untitled Song';
            const songNum = currentSong.song_id || currentSong.songnumber || currentSong.id;
            const songAuthor = currentSong.author || 'Unknown';
            const songLang = getSongLanguage(selectedSongForView);
            const songLyrics = currentSong.song || '';
            const engTitle = currentSong.eng_title;
            const engLyrics = currentSong.eng_lyrics;
            const songImage = currentSong.image || selectedSongForView.image;
            const orgName = selectedSongForView?.origanisation?.org_name || currentSong?.origanisation?.org_name;
            const isSongActive = (selectedSongForView?.status === 1 || currentSong?.status === 1);

            return (
              <>
                {/* Header Banner */}
                <Box
                  sx={{
                    p: 3,
                    background: isLight
                      ? 'linear-gradient(135deg, #0F766E 0%, #0D9488 100%)'
                      : 'linear-gradient(135deg, #115E59 0%, #134E4A 100%)',
                    color: '#FFFFFF',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    gap: 2,
                  }}
                >
                  <Box display="flex" gap={2} alignItems="center">
                    <Avatar
                      src={songImage || undefined}
                      sx={{
                        width: 64,
                        height: 64,
                        borderRadius: 2.5,
                        bgcolor: 'rgba(255,255,255,0.2)',
                        color: '#FFFFFF',
                        fontWeight: 800,
                        fontSize: 26,
                        border: '2px solid rgba(255,255,255,0.4)',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                      }}
                    >
                      {songTitle[0]?.toUpperCase() || <MusicNoteIcon sx={{ fontSize: 32 }} />}
                    </Avatar>
                    <Box>
                      <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                        {songNum && (
                          <Chip
                            label={`#${songNum}`}
                            size="small"
                            sx={{
                              bgcolor: 'rgba(255,255,255,0.25)',
                              color: '#FFFFFF',
                              fontWeight: 800,
                              fontSize: '0.75rem',
                              height: 22,
                            }}
                          />
                        )}
                        <Chip
                          label={songLang}
                          size="small"
                          sx={{
                            bgcolor: 'rgba(255,255,255,0.2)',
                            color: '#FFFFFF',
                            fontWeight: 700,
                            fontSize: '0.75rem',
                            height: 22,
                          }}
                        />
                        <Chip
                          label={isSongActive ? "Active" : "Inactive"}
                          size="small"
                          sx={{
                            bgcolor: isSongActive ? '#10B981' : '#64748B',
                            color: '#FFFFFF',
                            fontWeight: 700,
                            fontSize: '0.75rem',
                            height: 22,
                          }}
                        />
                        {orgName && (
                          <Chip
                            label={orgName}
                            size="small"
                            sx={{
                              bgcolor: 'rgba(255,255,255,0.15)',
                              color: '#FFFFFF',
                              fontWeight: 600,
                              fontSize: '0.72rem',
                              height: 22,
                            }}
                          />
                        )}
                      </Box>
                      <Typography variant="h5" fontWeight={800} sx={{ mt: 0.8, color: '#FFFFFF' }}>
                        {songTitle}
                      </Typography>
                      {songAuthor && (
                        <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.3 }}>
                          By: <strong>{songAuthor}</strong>
                        </Typography>
                      )}
                    </Box>
                  </Box>
                  <IconButton
                    onClick={() => {
                      setSongDetailModalOpen(false);
                      setSelectedSongForView(null);
                    }}
                    sx={{ color: '#FFFFFF', '&:hover': { bgcolor: 'rgba(255,255,255,0.15)' } }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>

                <DialogContent sx={{ p: 3, maxHeight: '65vh', overflowY: 'auto' }}>
                  {/* Lyrics container */}
                  <Box display="flex" flexDirection="column" gap={3}>
                    {/* Primary Song Lyrics */}
                    <Paper
                      variant="outlined"
                      sx={{
                        p: 3,
                        borderRadius: 2.5,
                        bgcolor: isLight ? '#F8FAFC' : 'rgba(255,255,255,0.02)',
                        borderColor: isLight ? '#E2E8F0' : 'rgba(255,255,255,0.08)',
                      }}
                    >
                      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1.5} pb={1} borderBottom={isLight ? '1px solid #E2E8F0' : '1px solid rgba(255,255,255,0.08)'}>
                        <Typography variant="subtitle2" fontWeight={800} sx={{ color: isLight ? '#0F766E' : '#2DD4BF', textTransform: 'uppercase', letterSpacing: 0.8 }}>
                          Lyrics ({songLang})
                        </Typography>
                        {songNum && (
                          <Typography variant="caption" sx={{ color: isLight ? '#64748B' : '#94A3B8', fontWeight: 600 }}>
                            Song #{songNum}
                          </Typography>
                        )}
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          whiteSpace: 'pre-line',
                          fontFamily: "'Segoe UI', 'Roboto', sans-serif",
                          lineHeight: 1.85,
                          fontSize: '1rem',
                          color: isLight ? '#1E293B' : '#F1F5F9',
                        }}
                      >
                        {songLyrics || 'No lyrics available for this song.'}
                      </Typography>
                    </Paper>

                    {/* English Lyrics if available */}
                    {(engTitle || engLyrics) && (
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 3,
                          borderRadius: 2.5,
                          bgcolor: isLight ? '#F0FDFA' : 'rgba(13, 148, 136, 0.05)',
                          borderColor: isLight ? '#CCFBF1' : 'rgba(13, 148, 136, 0.2)',
                        }}
                      >
                        <Typography variant="subtitle2" fontWeight={800} sx={{ color: isLight ? '#0F766E' : '#2DD4BF', textTransform: 'uppercase', letterSpacing: 0.8, mb: 1, pb: 1, borderBottom: isLight ? '1px solid #CCFBF1' : '1px solid rgba(13,148,136,0.2)' }}>
                          English Version: {engTitle || songTitle}
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            whiteSpace: 'pre-line',
                            lineHeight: 1.85,
                            fontSize: '0.98rem',
                            color: isLight ? '#1E293B' : '#F1F5F9',
                          }}
                        >
                          {engLyrics || 'No English lyrics provided.'}
                        </Typography>
                      </Paper>
                    )}
                  </Box>
                </DialogContent>

                <DialogActions sx={{ p: 2, px: 3, borderTop: isLight ? '1px solid #E2E8F0' : '1px solid rgba(255,255,255,0.08)', gap: 1 }}>
                  <Button
                    onClick={() => {
                      setSongDetailModalOpen(false);
                      handleEdit(currentSong.id);
                    }}
                    variant="contained"
                    startIcon={<EditIcon />}
                    size="small"
                    sx={{
                      bgcolor: '#0D9488',
                      '&:hover': { bgcolor: '#0F766E' },
                      textTransform: 'none',
                      fontWeight: 700,
                      borderRadius: 2
                    }}
                  >
                    Edit Song
                  </Button>
                  <Button
                    onClick={() => {
                      setSongDetailModalOpen(false);
                      setSelectedSongForView(null);
                    }}
                    variant="outlined"
                    color="inherit"
                    size="small"
                    sx={{ textTransform: 'none', borderRadius: 2 }}
                  >
                    Close
                  </Button>
                </DialogActions>
              </>
            );
          })()}
        </Dialog>


          </>
        )}
      </Box>

      {/* Duplicate Songs Replacement Alert Dialog */}
      <Dialog
        open={duplicateConfirmDialog.open}
        onClose={() => setDuplicateConfirmDialog(prev => ({ ...prev, open: false }))}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            bgcolor: isLight ? "#FFFFFF" : "#1A2634",
            border: isLight ? "1px solid #E2E8F0" : "1px solid rgba(245, 158, 11, 0.4)",
            boxShadow: "0 10px 30px rgba(0,0,0,0.3)"
          }
        }}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5, pb: 1 }}>
          <Box sx={{ width: 40, height: 40, borderRadius: "50%", bgcolor: "rgba(245, 158, 11, 0.15)", display: "flex", alignItems: "center", justifyContent: "center", color: "#F59E0B" }}>
            <WarningAmberIcon sx={{ fontSize: 24 }} />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight={700}>
              {duplicateConfirmDialog.title || "Duplicate Song Detected"}
            </Typography>
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              Song already exists in the songbook
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2, color: isLight ? "#334155" : "#E2E8F0", lineHeight: 1.6 }}>
            {duplicateConfirmDialog.message}
          </Typography>
          {duplicateConfirmDialog.duplicates?.length > 0 && (
            <Box sx={{ maxHeight: 150, overflowY: "auto", p: 1.5, bgcolor: isLight ? "#F8FAFC" : "rgba(255,255,255,0.04)", borderRadius: 2, border: "1px solid rgba(255,255,255,0.08)" }}>
              {duplicateConfirmDialog.duplicates.slice(0, 5).map((d, i) => (
                <Typography key={i} variant="caption" sx={{ display: "block", fontWeight: 600, color: "#F59E0B" }}>
                  • {d.title} {d.author ? `(${d.author})` : ''}
                </Typography>
              ))}
              {duplicateConfirmDialog.duplicates.length > 5 && (
                <Typography variant="caption" sx={{ color: "text.secondary", mt: 0.5, display: "block" }}>
                  ...and {duplicateConfirmDialog.duplicates.length - 5} more
                </Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, px: 3, borderTop: isLight ? "1px solid #E2E8F0" : "1px solid rgba(255,255,255,0.08)", gap: 1 }}>
          <Button
            variant="outlined"
            onClick={() => setDuplicateConfirmDialog(prev => ({ ...prev, open: false }))}
            sx={{ textTransform: "none", borderRadius: 2 }}
          >
            Cancel
          </Button>
          <Button
            variant="outlined"
            color="warning"
            onClick={duplicateConfirmDialog.onConfirmSkip}
            sx={{ textTransform: "none", borderRadius: 2 }}
          >
            Skip Duplicates
          </Button>
          <Button
            variant="contained"
            onClick={duplicateConfirmDialog.onConfirmReplace}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              background: "linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)",
              fontWeight: 700
            }}
          >
            Yes, Replace Existing
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add New Song Collection Modal */}
      <Dialog
        open={newSectionModalOpen}
        onClose={() => setNewSectionModalOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            bgcolor: isLight ? "#FFFFFF" : "#1A2634",
            border: isLight ? "1px solid #E2E8F0" : "1px solid rgba(76, 161, 175, 0.3)"
          }
        }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box display="flex" alignItems="center" gap={1}>
            <LibraryMusicIcon sx={{ color: "#0D9488" }} />
            <Typography variant="h6" fontWeight={700}>Add New Song Collection</Typography>
          </Box>
          <IconButton size="small" onClick={() => setNewSectionModalOpen(false)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Create a new song collection/section (e.g. "Daily Devotions", "Sunday Hymns", "Youth Worship") and organize songs under it.
          </Typography>
          <TextField
            label="Collection / Section Name"
            placeholder="e.g. Daily Devotions"
            fullWidth
            size="small"
            value={newSectionName}
            onChange={(e) => setNewSectionName(e.target.value)}
            required
            autoFocus
          />
          <TextField
            label="Description (Optional)"
            placeholder="Brief description of this songbook..."
            fullWidth
            size="small"
            multiline
            rows={2}
            value={newSectionDesc}
            onChange={(e) => setNewSectionDesc(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, px: 3, borderTop: isLight ? "1px solid #E2E8F0" : "1px solid rgba(255,255,255,0.08)" }}>
          <Button variant="outlined" onClick={() => setNewSectionModalOpen(false)} sx={{ textTransform: "none", borderRadius: 2 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleCreateNewSection}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              background: "linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)",
              fontWeight: 700
            }}
          >
            Create Collection
          </Button>
        </DialogActions>
      </Dialog>

      {/* PDF Song Viewer Modal */}
      <Dialog
        open={Boolean(selectedPdfUrl)}
        onClose={() => setSelectedPdfUrl(null)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            height: "85vh",
            borderRadius: 3,
            bgcolor: isLight ? "#FFFFFF" : "#1E293B",
            overflow: "hidden"
          }
        }}
      >
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: 1.5, px: 2.5, borderBottom: isLight ? "1px solid #E2E8F0" : "1px solid rgba(255,255,255,0.1)" }}>
          <Box display="flex" alignItems="center" gap={1}>
            <PictureAsPdfIcon sx={{ color: "#EF4444" }} />
            <Typography variant="subtitle1" fontWeight={700}>PDF Song Viewer</Typography>
          </Box>
          <IconButton size="small" onClick={() => setSelectedPdfUrl(null)}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0, height: "100%", bgcolor: "#000" }}>
          {selectedPdfUrl && (
            <iframe
              src={selectedPdfUrl}
              title="PDF Song Viewer"
              width="100%"
              height="100%"
              style={{ border: "none" }}
            />
          )}
        </DialogContent>
      </Dialog>

      <Toast toast={toast} setToast={setToast} />
      <ConfirmDialog
        open={confirmDialog.open}
        title={confirmDialog.title}
        message={confirmDialog.message}
        onConfirm={confirmDialog.onConfirm}
        onCancel={() => setConfirmDialog({ ...confirmDialog, open: false })}
        severity="error"
      />
      <ModuleSettingsModal open={settingsOpen} onClose={() => setSettingsOpen(false)} moduleKey="songs" moduleTitle="Songs" />
      <MobileSongPreviewModal
        open={mobileExampleOpen}
        onClose={() => setMobileExampleOpen(false)}
        churchName={user?.origanisation?.org_name || 'Way Truth Life Church'}
      />
    </>
  );
};

export default Songs;
